export enum RoleEnum {
  ADMIN = 1,
  MARKETING = 2,
  SALES = 3
}
